/* eslint-disable @typescript-eslint/no-redeclare */
export type CompanyFileType =
  (typeof CompanyFileType)[keyof typeof CompanyFileType];
export const CompanyFileType = {
  TEMPLATE_IMAGE: 'TEMPLATE_IMAGE',
} as const;
